import { initializeApp } from 'firebase/app';
import * as firebaseAuth from 'firebase/auth';
import config from './config';

const firebaseApp = initializeApp(config.env.firebase);

export const app = firebaseApp;
export const auth = firebaseAuth.getAuth(firebaseApp);

export const signInWithEmailAndPassword = (email: string, password: string) =>
  firebaseAuth.signInWithEmailAndPassword(auth, email, password);
export const signOut = () => firebaseAuth.signOut(auth);
